// Manages subtasks progress updates
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['progressBar', 'progressText', 'progressContainer']

  renderProgress(data) {
    const { completed, total, percentage } = data
    
    if (this.hasProgressBarTarget) {
      // Update progress bar width and maintain primary color
      this.progressBarTarget.style.width = `${percentage}%`
      this.progressBarTarget.style.backgroundColor = 'var(--ct-primary)'
      this.progressBarTarget.setAttribute('aria-valuenow', percentage)
    }

    if (this.hasProgressTextTarget) {
      // Update progress text
      this.progressTextTarget.textContent = `${completed} / ${total}`
    }

    // Optional: Add animation class when updating
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.transition = 'width 0.3s ease'
    }
  }
}
